import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const BULK_API_PATH = '/api/products/bulk-updates';

const downloadTemplate = async () => {
  const response = await axios.get(`${API_BASE_URL}${BULK_API_PATH}/template`, {
    responseType: 'blob',
  });
  return response.data;
};

const listJobs = async (limit = 20) => {
  const response = await axios.get(`${API_BASE_URL}${BULK_API_PATH}`, {
    params: { limit },
  });
  return response.data.data || [];
};

const uploadJob = async ({ file, pricingScopeMode, storeIds = [] }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('pricingScopeMode', pricingScopeMode);
  formData.append('storeIds', JSON.stringify(storeIds));
  const response = await axios.post(`${API_BASE_URL}${BULK_API_PATH}/upload`, formData);
  return response.data.data;
};

const validateJob = async (jobId) => {
  const response = await axios.post(`${API_BASE_URL}${BULK_API_PATH}/${jobId}/validate`);
  return response.data.data;
};

const applyJob = async (jobId) => {
  const response = await axios.post(`${API_BASE_URL}${BULK_API_PATH}/${jobId}/apply`);
  return response.data.data;
};

const rollbackJob = async (jobId) => {
  const response = await axios.post(`${API_BASE_URL}${BULK_API_PATH}/${jobId}/rollback`);
  return response.data.data;
};

const downloadValidationReport = async (jobId) => {
  const response = await axios.get(`${API_BASE_URL}${BULK_API_PATH}/${jobId}/validation-report`, {
    responseType: 'blob',
  });
  return response.data;
};

const productBulkUpdateService = {
  downloadTemplate,
  listJobs,
  uploadJob,
  validateJob,
  applyJob,
  rollbackJob,
  downloadValidationReport,
};

export default productBulkUpdateService;
